export default __webpack_public_path__ + "static/media/iACST_Hero_final.5d3da4d6.png";